export default "__VITE_ASSET__CUByAgDU__"